import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'VGA Series',
      href: '/en/Motion_Detection/Setup/VGA_Series/',
    },
    {
      text: '720p Series',
      href: '/en/Motion_Detection/Setup/720p_Series/',
    },
    {
      text: '1080p Series',
      href: '/en/Motion_Detection/Setup/',
    },
    {
      text: '◄ Motion Detection',
      href: '/en/Motion_Detection/Setup/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={6}
        aria-label="Motion Detection Setup"
      />
      <EuiSpacer />
    </Fragment>
  );
}